import React, { useEffect, useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import CommonUtils from '../../util/CommonUtils';
import LocationCard from './LocationCard';
import ImageResize from '../common/ImageResize';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';
import Toastr from 'toastr';
import SitesHawkEye from './SitesHawkEye';
import Loading from '../Loading';
import API from '../../service/SiteKickAPIService';

function DashboardLeadership() {
    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');

    const [customer, setCustomer] = useState(null);
    const [zoneOrderChanged, setZoneOrderChanged] = useState(false);
    const [featuredLocationId, setFeaturedLocationId] = useState(null);
    const [siteLocationsLoaded, setSiteLocationsLoaded] = useState(!!user.site_locations);
    const [locationData, setLocationData] = useState({});

    useEffect(() => {
        fetchCustomer();

        if (!user.site_locations) {
            fetchSiteLocations();
        }

        let sortableContainer = $('.sortable');
        sortableContainer.sortable({
            placeholder: ".sortable-placeholder",
            forcePlaceholderSize: true,
            cancel: '[data-featured="true"], [data-no-sort="true"]',
            stop: (event, ui) => {
                setZoneOrderChanged(true);
            }
        });
    }, []);

    const fetchCustomer = async () => {
        let _c = await CommonUtils.getCustomer(user.customer_id || user.site_selected.customer_id, user);
        setCustomer(_c);

        // Auto-feature the first location
        if (_c && _c.leadership_sites) {
            let recs = [];
            for (let s of Object.keys(_c.leadership_sites))
                for (let l of _c.leadership_sites[s])
                    recs.push({ location_id: l, site_id: s });
            if (_c.zone_prefs)
                recs.sort((x, y) => _c.zone_prefs.indexOf(x.location_id) - _c.zone_prefs.indexOf(y.location_id));
            if (recs.length > 0)
                setFeaturedLocationId(recs[0].location_id);
        }
    }

    const fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        };
        CommonUtils.ajax({
            url: API.SITE.BASE,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then((res) => {
            if (res.status && res.status.code === 200) {
                let _user = JSON.parse(JSON.stringify(user));
                _user.site_locations = res.data ? res.data.filter(x => x.site_state.trim().toUpperCase() !== 'INACTIVE') : [];
                sessionManager.storeCookie('user', _user);
                setSiteLocationsLoaded(true);
            }
        });
    }

    const onFeatureStream = (_site, location) => {
        setFeaturedLocationId(prev => prev === location.location_id ? null : location.location_id);
    }

    const onLocationLoaded = (location, site) => {
        setLocationData(prev => ({ ...prev, [location.location_id]: { location, site } }));
    }

    let site_loc_recs = [];
    if (customer && customer.leadership_sites) {
        for (let s of Object.keys(customer.leadership_sites))
            for (let l of customer.leadership_sites[s]) {
                site_loc_recs.push({ location_id: l, site_id: s });
            }
        if (site_loc_recs && customer.zone_prefs) {
            site_loc_recs.sort((x, y) => customer.zone_prefs.indexOf(x.location_id) - customer.zone_prefs.indexOf(y.location_id))
        }
    }

    const saveZoneOrderPreferences = async () => {
        let sortableContainer = $('.sortable');
        console.log('customer.leadership_sites', customer.leadership_sites)
        const zone_prefs = sortableContainer.sortable('toArray', { attribute: 'zone' });
        if (customer.customer_id && zone_prefs.length > 0) {
            let result = await CommonUtils.saveCustomer({ customer_id: customer.customer_id, zone_prefs: zone_prefs }, user);
            if (result) {
                Toastr.success('Preferences saved !');
                setZoneOrderChanged(false);
            }
        }
    }

    return (
        <div className="page-container">
            {/* MAP SECTION */}
            <div className="row mb-2">
                <div className="col-12">
                    {siteLocationsLoaded
                        ? <SitesHawkEye dropdown="true" mapHeight="40vh" />
                        : <Loading>Loading map...</Loading>}
                </div>
            </div>

            {/* VIDEO STREAMS
                All cards live in ONE flex container so React never unmounts them.
                Featured card: order -1 → visually "row 1" (full width).
                Separator div: order 0 → divides the two rows.
                Thumbnails:    order 1 → visually "row 2" (small tiles).
            */}
            <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="bold text-primary font-size-14 mb-0">Live Video Streams</h6>
                    {zoneOrderChanged && (
                        <button className="btn btn-sm btn-primary" onClick={saveZoneOrderPreferences}>Save Preferences</button>
                    )}
                </div>

                {customer ? (
                    site_loc_recs.length > 0 ? (
                        <div className="sortable" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>

                            {/* Separator — only shown when a featured card is active */}
                            {featuredLocationId && (
                                <div style={{
                                    order: 0, flex: '0 0 100%',
                                    borderTop: '1px solid #dee2e6',
                                    padding: '4px 2px 2px',
                                    fontSize: '11px', color: '#888', letterSpacing: '0.3px'
                                }}>
                                    All Streams
                                </div>
                            )}

                            {site_loc_recs.map(sl => {
                                const isFeatured = featuredLocationId === sl.location_id;
                                const locData = locationData[sl.location_id];
                                const snapImage = locData
                                    ? `https://sitesupt-location-data.s3.amazonaws.com/cusr_${locData.location.customer_id}/site_${locData.location.site_id}/location_${sl.location_id}/image_${locData.location.device_id}_${locData.location.location_last_pic_pic_time}.jpg`
                                    : null;
                                return (
                                    <React.Fragment key={sl.location_id}>
                                        <div
                                            zone={sl.location_id}
                                            data-featured={isFeatured || undefined}
                                            style={{
                                                order: isFeatured ? -1 : 1,
                                                flex: isFeatured ? '0 0 100%' : '0 0 calc(16.666% - 6px)',
                                                minWidth: isFeatured ? '100%' : '110px',
                                            }}
                                        >
                                            <LocationCard
                                                site_id={sl.site_id}
                                                location_id={sl.location_id}
                                                onFeatureStream={onFeatureStream}
                                                onLocationLoaded={onLocationLoaded}
                                                isFeatured={isFeatured}
                                                playInTile={!!featuredLocationId && !isFeatured}
                                                compact={true}
                                            />
                                        </div>

                                        {/* Highlighted thumbnail placeholder shown in grid while this card is featured */}
                                        {isFeatured && (
                                            <div
                                                data-no-sort="true"
                                                onClick={() => onFeatureStream(null, { location_id: sl.location_id })}
                                                style={{
                                                    order: 1,
                                                    flex: '0 0 calc(16.666% - 6px)',
                                                    minWidth: '110px',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <div style={{
                                                    position: 'relative',
                                                    aspectRatio: '16/10',
                                                    borderRadius: '10px',
                                                    overflow: 'hidden',
                                                    border: '2px solid #1976d2',
                                                    boxShadow: '0 0 0 2px rgba(25,118,210,0.4), 0 4px 16px rgba(25,118,210,0.3)',
                                                }}>
                                                    {snapImage && (
                                                        <ImageResize src={snapImage} resize_perc="0.2" alt="" style={{
                                                            position: 'absolute', inset: 0,
                                                            width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55,
                                                        }} />
                                                    )}
                                                    <div style={{
                                                        position: 'absolute', inset: 0,
                                                        background: 'rgba(25,118,210,0.2)',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    }}>
                                                        <span style={{
                                                            background: '#1976d2', color: '#fff',
                                                            fontSize: '8px', fontWeight: 800,
                                                            padding: '2px 7px', borderRadius: '4px', letterSpacing: '1px',
                                                        }}>▶ PLAYING</span>
                                                    </div>
                                                    {locData && (
                                                        <div style={{
                                                            position: 'absolute', bottom: 0, left: 0, right: 0,
                                                            padding: '4px 6px',
                                                            background: 'rgba(0,0,0,0.6)',
                                                            color: '#fff', fontSize: '10px', fontWeight: 700,
                                                            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                                        }}>
                                                            {locData.location.location_name}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    ) : <div className="p-3">No sites configured for leadership to view.</div>
                ) : <div className="p-3">Loading...</div>}
            </div>
        </div>
    )
}

export default DashboardLeadership;
